import React from 'react';
import resumeData from '../data/resumeData.json';

const Education = ({ data = resumeData.education }) => {
  return (
    <section className="o-section t-section">
      <div className="o-section__header-bg t-section__header"></div>
      <div className="o-section__content-bg t-section__content"></div>

      <div className="o-container">
        <div className="o-section__container">
          <header className="o-section__header t-section__header">
            <div className="o-content">
              <h2 className="o-section__heading">{data.heading}</h2>
              <div className="o-content__body o-section__description">{data.description}</div>
            </div>
          </header>

          <div className="o-section__content t-section__content u-pt-0">
            <div className="o-content">
              <div className="a-education-timeline c-timeline t-border-color o-section__full-top-space">
                <div className="c-timeline__end t-border-color"></div>

                {(data.items || []).map((item) => (
                  <div className="c-timeline__item" key={item.id}>
                    <div className="c-timeline__point t-timeline__point t-primary-bg"></div>
                    <div className="o-content">
                      <div className="o-grid">
                        <div className="o-grid__col-md-5">
                          <div className="c-work__timeframe">{item.period}</div>
                          <h3 className="c-work__heading">{item.school}</h3>
                          <h4 className="c-work__title">{item.degree}</h4>
                          <div className="c-work__location">{item.location}</div>
                        </div>
                        <div className="o-grid__col-md-7">
                          <p>{item.details}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
